
import { useContext, useState, useEffect } from 'react';
import { decodeToken}  from '../../services/tokenValidator';

import AuthContext from '../../store/AuthContext';
import CopyButton from '../widgets/CopyButton';
import * as utils from '../../services/utils';

function DecodedToken () {   
  const iuaCtx = useContext(AuthContext);

  const token = iuaCtx.accessToken;
  
  const [tokenHeader, setTokenHeader] =  useState(''); 
  const [tokenPayload, setTokenPayload] =  useState(''); 
  const [tokenSignature, setTokenSignature] =  useState(''); 
  const [algorithm, setAlgorithm] =  useState(''); 
  const [tokenJson, setTokenJson] =  useState(''); 
  
  useEffect(() => {
    token && decodeAccessToken();
  },[iuaCtx.accessToken]);

  useEffect(() => {
    token && buildTokenJson();
  },[tokenHeader, tokenPayload, tokenSignature]);

  const tokenSignaturePre = algorithm + '(\n' +
    '   base64UrlEncode(header) + "." + \n' +
    '   base64UrlEncode(payload), '
  const tokenSignaturePost = '\n)';

  function buildTokenJson() {
    const decodedToken = tokenHeader?.concat('\n')
      .concat(tokenPayload).concat('\n')
      .concat(tokenSignaturePre).concat('\n')
      .concat(tokenSignature).concat('\n')
      .concat(tokenSignaturePost).concat('\n');
      
    setTokenJson(decodedToken);
  }

  function decodeAccessToken() {
    decodeToken(token)
      .then(result => {
        const tokenHeader =  JSON.stringify(result.decodedToken.header, null, 2); 
        const tokenPayload = JSON.stringify(result.decodedToken.payload, null, 2);
        const tokenSignatureJwk = JSON.stringify(result.jwk, null, 2); 
        setTokenHeader(tokenHeader);
        setTokenPayload(tokenPayload);
        setTokenSignature(tokenSignatureJwk); 

        const alg = utils.getAlgorithm(result.decodedToken.header.alg);
        setAlgorithm(alg);
      });
  }

  return (
    <div>   
      {token && <div className="card card-body code-block success" title="Decoded Access Token">
      <div className="main-form-output white-text"> 
        <span className="code-line"> Token Header:</span>
        <span className="light-pink-text"><pre>{tokenHeader}</pre></span>
        <span className="code-line"> Token Payload:</span>      
        <span className="light-purple-text"><pre>{tokenPayload}</pre></span> 
        <span className="code-line"> Token Signature:</span> 
        <span className="light-blue-text"><pre className='reg'>{tokenSignaturePre}</pre></span>
        <span className="code-line code-line-param light-blue-text"><pre className='reg'>{tokenSignature}</pre></span>
        <span className="light-blue-text">{tokenSignaturePost}</span>
        <CopyButton data={tokenJson}></CopyButton>
      </div>
    </div>}
  </div>
  );

}

export default DecodedToken;